






































import { PredefinedAltActionOptions, PredefinedOptionType, SystemEvent } from '@/common/bot/enum';
import { AlternativeActionSelectedEvent, BaseSystemMessage } from '@/common/bot/types';
import CustomerSupportIcon from '@/components/icons/CustomerSupportIcon.vue';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
  components: {
    CustomerSupportIcon,
  },
})
export default class AlternativeActionsMessage extends Vue {
  @Prop({ default: () => ({}) }) readonly message!: BaseSystemMessage;

  readonly PredefinedOptionType = PredefinedOptionType;

  buildAlternativeActionEvent (selected: PredefinedAltActionOptions) {
    const $event: AlternativeActionSelectedEvent = {
      message: this.message,
      type: SystemEvent.ALTERNATIVE_ACTION,
      payload: { selected },
    };

    this.$emit('send:event', $event);
  }
}
